var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
import { jsx as _jsx } from "react/jsx-runtime";
import { REJECTION_CODES_TEXT } from "../../../../../constants/rejectionCodes.constants";
import { useCodesTable } from "../hook/codesTable.hook";
import { StyledCodesTable } from "../../../../codesTable.style";
import { CodesTableWrapper } from "../style/codesTable.style";
export var CodesTableView = function (props) {
    var _a;
    var p = useCodesTable(props);
    return (_jsx(CodesTableWrapper, { children: _jsx(StyledCodesTable, __assign({ columns: p.columns, rows: p.rows, emptyMessage: REJECTION_CODES_TEXT.codesEmptyMessage }, (props.editable
            ? {
                editingId: (_a = p.editingId) !== null && _a !== void 0 ? _a : "",
                onEditStart: p.onEditStart,
                onSave: p.onSave,
                onCancel: p.onCancelEdit,
            }
            : {}))) }));
};
